import { FormBase } from 'core/components';

export default class ProductOrderingEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'productId',
                    label: 'PRODUCT_ORDERING.CREATE.PRODUCT_LABEL',
                    placeholder: 'PRODUCT_ORDERING.CREATE.PRODUCT_PLACEHOLDER',
                    rules: 'required|string'
                },
                {
                    name: 'subCategoryId',
                    label: 'PRODUCT_ORDERING.CREATE.SUB_CATEGORY_LABEL',
                    placeholder: 'PRODUCT_ORDERING.CREATE.SUB_CATEGORY_PLACEHOLDER',
                    rules: 'required|string'
                },
                {
                    name: 'sort',
                    label: 'PRODUCT_ORDERING.CREATE.SORT_LABEL',
                    placeholder: 'PRODUCT_ORDERING.CREATE.SORT_LABEL',
                    rules: ['min:1'],
                    type: 'integer'
                },
            ],
        };
    }
}
